import React from 'react';
import PropTypes from 'prop-types';
import Entity from '../../Entity';
import { reducedFeesDescOtcqx, reducedFeesDescOtcqb, reducedFeeOtcqxSectionTitle, reducedFeeOtcqbSectionTitle, reducedFeeTitle } from './PaymentSubmit.constants';

const ReducedFeeSection = ({ state, payment, handleSlideOut, handleRemove }) => {
    const { application, sessionPayment } = state;
    const isOTCQX = application.typeId === 1 || application.typeId === 2 || application.typeId === 3;
    const isOTCQB = application.typeId === 4;
    const reduceFeeOptionSelected = sessionPayment?.reducedFeeType;
    const hasPaymentType = sessionPayment?.paymentType;

    if (hasPaymentType) {
        return null;
    }

    return (
        <>
            {isOTCQX && (
                <>
                    <p>{reducedFeeOtcqxSectionTitle}</p>
                    <Entity
                        testId='reduced-fee-otcqx'
                        isComplete={reduceFeeOptionSelected}
                        icon={reduceFeeOptionSelected ? 'check' : null}
                        title={reduceFeeOptionSelected ? reducedFeesDescOtcqx.get(payment.reducedFeeType) : reducedFeeTitle}
                        subTitle="Find Out More"
                        size="small"
                        handleRemove={handleRemove}
                        onClick={handleSlideOut}
                    />
                </>
            )}
            {isOTCQB && (
                <>
                    <p>{reducedFeeOtcqbSectionTitle}</p>
                    <Entity
                        testId='reduced-fee-otcqb'
                        isComplete={reduceFeeOptionSelected}
                        icon={reduceFeeOptionSelected ? 'check' : null}
                        title={reduceFeeOptionSelected ? reducedFeesDescOtcqb.get(payment.reducedFeeType) : reducedFeeTitle}
                        subTitle="Find Out More"
                        size="small"
                        handleRemove={handleRemove}
                        onClick={handleSlideOut}
                    />
                </>
            )}
        </>
    );
};

ReducedFeeSection.propTypes = {
    state: PropTypes.object.isRequired,
    payment: PropTypes.object.isRequired,
    handleSlideOut: PropTypes.func.isRequired,
    handleRemove: PropTypes.func.isRequired,
};

export default ReducedFeeSection;